import { updateLinksAttributes } from '../utils/handleAttributes';
import { missingWidget } from '../utils/helpers';

export default function customTicketButton() {
  const widgetName = 'customTicketButton';
  const $widget = $(`#${widgetName}`);
  const widgetOpts = typeof customTicketButtonOpts === 'undefined' ? null : customTicketButtonOpts;

  if (!widgetOpts) {
    $widget.remove();
    missingWidget(widgetName);
    return;
  }

  return saffire.widgets.cardWidget($widget, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomTicketBtn(data);
      } else {
        $widget.remove();
      }
    },
  });

  function createCustomTicketBtn(widgetData) {
    const { Title, URL } = widgetData.items[0];

    if (URL == null) {
      $widget.remove();
      missingWidget(widgetName);
      return;
    }
    $widget.find('.card-widget-item').replaceWith(
      `<a class="btn-wrap" tabindex="0" href="${URL}" ${updateLinksAttributes(URL, Title)}>
            <span class="btn-label">${Title}</span>
        </a>`,
    );
  }
}
